import "./pitch.css";
import { PitchIcon, type PitchIconName } from "./PitchIcons";

export const PROBLEM_SCENE_COPY = {
  topBubbles: [
    { text: "Can I swap Saturday?", side: "left" },
    { text: "Off sick today, sorry", side: "right" },
  ],
  bottomBubbles: [
    { text: "Leave on the 12th?", side: "left" },
    { text: "Can anyone cover 06:00?", side: "right" },
  ],
  fileName: "roster_v7_FINAL (2).xlsx",
  sticky: "Check rest after the night shift!",
  unread: "37",
  illustrative: "Illustrative",
  labels: [
    "Leave tracked in many places",
    "Rules checked by hand",
    "Standby sized by guesswork",
    "Changes handled by phone",
  ],
};

const LABEL_ICONS: PitchIconName[] = ["database", "search", "team", "member"];

const CELLS = "dddldwdddlddlbddlddldddddlddbdldddd".split("").map((k, i) => ({
  id: i,
  kind: k === "l" ? "light" : k === "w" ? "warn" : k === "b" ? "bad" : "base",
}));

export interface ProblemSceneProps {
  copy?: typeof PROBLEM_SCENE_COPY;
}

/** `wrong.html`: the usual week of a planner, drawn, with four labels. */
export function ProblemScene({ copy = PROBLEM_SCENE_COPY }: ProblemSceneProps) {
  return (
    <div className="pitch pitch-scene-wrap">
      <div className="pitch-scene">
        <div className="pitch-scene-row">
          {copy.topBubbles.map((b) => (
            <p key={b.text} className="pitch-bubble" data-side={b.side}>
              {b.text}
            </p>
          ))}
        </div>
        <div className="pitch-mid">
          <div className="pitch-file">
            <p className="pitch-file-name">{copy.fileName}</p>
            <div className="pitch-cells">
              {CELLS.map((c) => (
                <span key={c.id} className="pitch-cell" data-k={c.kind} />
              ))}
            </div>
          </div>
          <p className="pitch-sticky">{copy.sticky}</p>
        </div>
        <div className="pitch-scene-row">
          <span className="pitch-counter">{copy.unread}</span>
          {copy.bottomBubbles.map((b) => (
            <p key={b.text} className="pitch-bubble" data-side={b.side}>
              {b.text}
            </p>
          ))}
        </div>
      </div>
      <ul className="pitch-labels">
        {copy.labels.map((label, i) => (
          <li key={label} className="pitch-label">
            <span className="pitch-badge">
              <PitchIcon name={LABEL_ICONS[i % LABEL_ICONS.length] ?? "search"} size={26} />
            </span>
            {label}
          </li>
        ))}
        <li className="pitch-illustrative">{copy.illustrative}</li>
      </ul>
    </div>
  );
}
